import type { Release } from '../releases.ts';

export default {
  version: '0.9.0',
  date: '2026-09-29',
  title: 'Storage, transcoding and teamwork',
  summary: [
    'Storage and watch folders are kept under separate roots',
    'Add S3 and OCI buckets in the app, with encrypted keys',
    'Several export locations, including folders on storage agents',
    'Transcode profiles in FFmpeg syntax',
    'Tasks: assign assets, edits and collections to people or groups',
    'Fixed: a file dropped into a watch folder again is ingested again',
  ],
  features: [
    'Storage kept apart from ingest: storage and export folders under their own root, watch folders under another',
    'S3 and OCI Object Storage buckets added in the UI, with encrypted keys, a streaming check and credential rotation',
    'Storage agents with a storage root and a watch root, folders chosen in PRISM, and a configuration pane per agent',
    'Several export locations, chosen when exporting, with delivery to folders on storage agents',
    'Removing a storage location warns first and can move its files out',
    'Transcode profiles in FFmpeg syntax for renditions and the proxy format',
    'Workflow Delete step, and Copy to storage of a transcode output',
    'Exports and transcodes fetch originals from storage agents and clean up after',
    'Job and log retention settings',
    'Asset categories and relations between assets',
    'Tasks: assign assets, edits and collections to people or groups, with notes and deadlines',
    'System status shows only current services, and Jobs and Logs have time filters',
  ],
  fixes: [
    'Ingests keep their outcome after the asset is purged',
    'A file dropped into a watch folder again is ingested again',
    'Storage agents wait properly for work instead of polling continuously',
  ],
} satisfies Release;
